(function () {
  // Guard: only run once
  if (window.__GGG_FC_INIT__) return;
  window.__GGG_FC_INIT__ = true;

  function initCarousel(root) {
    const track = root.querySelector('.ggg-fc__track');
    const prev = root.querySelector('.ggg-fc__nav--prev');
    const next = root.querySelector('.ggg-fc__nav--next');
    const autoplay = root.dataset.autoplay === 'true';
    const interval = Math.max(1500, parseInt(root.dataset.interval || '3000', 10) || 3000);

    // Respect reduced motion
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer = null;

    function cardWidth() {
      const first = track.querySelector('.ggg-fc__card');
      if (!first) return track.clientWidth;
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0');
      return first.getBoundingClientRect().width + gap;
    }

    function scrollByDir(dir) { track.scrollBy({ left: dir * cardWidth(), behavior: 'smooth' }); }
    function nextSlide() { scrollByDir(1); }
    function prevSlide() { scrollByDir(-1); }

    prev && prev.addEventListener('click', prevSlide);
    next && next.addEventListener('click', nextSlide);

    // Keyboard support on the track
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); nextSlide(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); prevSlide(); }
    });

    function start() {
      if (!autoplay || prefersReduced) return;
      stop();
      timer = setInterval(() => {
        const hovering = root.matches(':hover') || track.matches(':focus-within');
        if (hovering || document.hidden) return;
        nextSlide();
      }, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

    // Boot
    start();
  }

  function boot() {
    document.querySelectorAll('[data-fc]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
